(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('profileO365OnedriveFileInfo', ["path", "$q", "mainQueueTroubleshootingHelper", "widgetPolling", "mimeIcons", "fileDao", "sideMenuManager", "modulesDao", "metaInfoConverter", "rolesManager", "$interval", "$filter", "pathConverters", "deletedStatusHelper", "quarantineStatusConverter", "troubleshooting", "recheckParams", "$rootScope", "suspiciousReportParams", function (path, $q, mainQueueTroubleshootingHelper, widgetPolling, mimeIcons, fileDao, sideMenuManager, modulesDao, metaInfoConverter, rolesManager, $interval, $filter, pathConverters, deletedStatusHelper, quarantineStatusConverter, troubleshooting, recheckParams, $rootScope, suspiciousReportParams) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('profile/o365_onedrive_file/o365_onedrive-file-info').template('o365_onedrive-file-info'),
            scope: {},
            link: function ($scope, element, attrs) {
                var id = widgetPolling.scope().id;
                var updateTick = 30000;
                var restoreUpdateTickAfter;
                var updateWidget;
                var internalItemProperty = widgetPolling.scope().internal_item_property;
                function restartUpdating(promise, tick) {
                    if (promise) {
                        $interval.cancel(promise);
                    }
                    return $interval(function () {
                        $scope.loadData();
                    }, tick || 30000);
                }
                $scope.widgetApi = {};
                $scope.model = {};
                $scope.loadData = function () {
                    return $q.allSettled([
                        fileDao.entityInfo('o365_onedrive_file', id),
                        mimeIcons()
                    ]).then(function (responses) {
                        var input = {};
                        input.originData = responses[0].value && responses[0].value.data || {};
                        // Permissions
                        if (input.originData.permissions && input.originData.permissions.length) {
                            _(input.originData.permissions).each(function (pms) {
                                if (pms.hasOwnProperty('user')) {
                                    pms.type = 'user';
                                } else if (pms.hasOwnProperty('group')) {
                                    pms.type = 'group';
                                }
                                if (pms.type) {
                                    pms.id = pms[pms.type].id;
                                    pms.email = pms[pms.type].email;
                                    pms.displayName = pms[pms.type].displayName;
                                    pms.is_external = pms[pms.type].is_external;
                                }
                                pms.natural_order = 1;
                                pms.thumbnail_photo = null;
                            });
                        }
                        widgetPolling.scope().entityData = input.originData;
                        // info logic
                        var icons = responses[1].value;
                        var msgIcon = icons(input.originData.mimeType || 'text/plain');
                        var fileName = input.originData.filename;
                        var parentTitles = _([input.originData.file_path]).flatten();
                        if (internalItemProperty && input.originData[internalItemProperty] === false) {
                            fileName = '#' + JSON.stringify({
                                display: 'text',
                                text: input.originData.filename
                            }) + '#' + JSON.stringify({
                                display: 'text',
                                text: 'Internal',
                                'class': 'info-indicator-internal'
                            });
                        }
                        $scope.model.info = $scope.model.info || {};
                        var lines = [
                            {
                                img: msgIcon,
                                class: 'profile-image'
                            },
                            {
                                text: fileName,
                                class: 'file-name'
                            },
                            {
                                text: $filter('bytes')(input.originData.size),
                                class: 'file-size'
                            },
                            {
                                text: pathConverters.simplePath([], parentTitles),
                                class: 'file-parents'
                            }
                        ];
                        if (input.originData.av_fd_encrypted) {
                            lines.push({
                                class: 'file-encrypted-icon',
                                text: '#' + JSON.stringify({
                                    display: 'text',
                                    tooltip: 'File is encrypted',
                                    class: 'fa fa-lock'
                                })
                            });
                        }
                        if (!input.originData.is_deleted && _(input.originData.web_url).isString()) {
                            lines.push({
                                text: '#' + JSON.stringify({
                                    display: 'external-link',
                                    text: 'View file',
                                    href: input.originData.web_url
                                }),
                                class: 'file-link'
                            });
                        }
                        if (input.originData.is_deleted && deletedStatusHelper.isVisible('o365_onedrive_file', input.originData)) {
                            lines.push({
                                display: 'text',
                                text: 'Deleted',
                                class: 'file-deleted'
                            });
                        }
                        var quarantineMsg = quarantineStatusConverter('o365_onedrive_file', input.originData);
                        if (quarantineMsg) {
                            lines.push({
                                text: quarantineMsg,
                                class: 'quarantined'
                            });
                        }
                        var buttonsLine = {
                            text: '#' + JSON.stringify({
                                display: 'text',
                                text: 'Recheck',
                                'class': 'scan-action-button',
                                clickEvent: {
                                    name: 'file-recheck',
                                    entityId: id,
                                    entityType: 'o365_onedrive_file'
                                }
                            }),
                            class: { 'scan-actions-buttons': true }
                        };
                        if (troubleshooting.entityDebugEnabled()) {
                            buttonsLine.text += '#' + JSON.stringify({
                                display: 'text',
                                text: 'Report this file',
                                'class': 'scan-action-button',
                                clickEvent: {
                                    name: 'file-report',
                                    entityId: id,
                                    entityType: 'o365_onedrive_file'
                                }
                            });
                        }
                        lines.push(buttonsLine);
                        $scope.model.info.lines = lines;
                        $scope.model.virusHashMetaInfo = {
                            type: 'meta-info',
                            logic: {
                                name: 'virusHashMetaInfoLogic',
                                updateTick: null
                            },
                            class: 'virus-hash-info-widget',
                            wrapper: { type: 'none' },
                            pair: { class: 'virus-hash-meta-data' },
                            key: { class: 'virus-hash-meta-key' },
                            value: { class: 'virus-hash-meta-value' }
                        };
                        var queries = [modulesDao.entityInfo('o365_onedrive', 'o365_onedrive_file')];
                        var userInfo;
                        if (input.originData && input.originData.actor_id) {
                            queries.push(fileDao.entityInfo('o365_onedrive_user', input.originData.actor_id));
                            userInfo = queries.length - 1;
                        }
                        $q.allSettled(queries).then(function (respes) {
                            input.entityInfo = respes[0].value && respes[0].value.data || {};
                            input.resolvers = { actor_id: {} };
                            if (userInfo) {
                                input.resolvers.actor_id = respes[userInfo].value && respes[userInfo].value.data || {};
                            }
                            // meta-info logic
                            var metaInfo = {
                                key: {},
                                value: {},
                                pair: { class: 'file-meta-data' },
                                args: {
                                    beautifyKey: true,
                                    whiteList: [
                                        {
                                            key: 'actor_id',
                                            type: 'resolver',
                                            resolverEntity: 'o365_onedrive_user',
                                            resolverKey: 'display_name'
                                        },
                                        'modify_time',
                                        {
                                            key: 'mimetype_human',
                                            hiddenPairAny: { value: false }
                                        },
                                        'size',
                                        'file_path',
                                        'web_url',
                                        {
                                            key: 'is_external',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_quarantined',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_vaulted',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_restored',
                                            hiddenPairAny: { value: false }
                                        },
                                        {
                                            key: 'is_deleted',
                                            hiddenPairAny: { value: false }
                                        }
                                    ]
                                }
                            };
                            metaInfo.data = metaInfoConverter(input, metaInfo.args);
                            $scope.model.metaInfo = metaInfo;
                            // actions
                            if ($scope.model.actionsWidget) {
                                $scope.model.actionsWidget.entityData = input.originData;
                            } else {
                                $scope.model.actionsWidget = {
                                    type: 'actions',
                                    logic: {
                                        name: 'remediationActionsLogic',
                                        updateTick: 30000,
                                        entityType: 'o365_onedrive_file',
                                        entityDataSlave: true
                                    },
                                    'class': 'file-info-actions-widget wide-250-buttons',
                                    wrapper: { type: 'none' },
                                    actions: rolesManager.isActionAllowed([
                                        'admin',
                                        'user',
                                        'operations'
                                    ]) ? [
                                        {
                                            autoId: 'profile_manual_action_btn_o365_onedrive_file_quarantine_move',
                                            class: 'btn btn-blue',
                                            style: { width: '100%' },
                                            actionType: 'o365_onedrive_file_quarantine_move',
                                            hiddenEntityAny: {
                                                is_quarantined: true,
                                                is_deleted: true,
                                                is_vaulted: true
                                            }
                                        },
                                        {
                                            autoId: 'profile_manual_action_btn_o365_onedrive_file_quarantine_restore',
                                            class: 'btn btn-blue',
                                            style: { width: '100%' },
                                            actionType: 'o365_onedrive_file_quarantine_restore',
                                            hiddenEntityAny: {
                                                is_quarantined: false,
                                                is_deleted: true
                                            }
                                        },
                                        {
                                            autoId: 'profile_manual_action_btn_o365_onedrive_file_vault_move',
                                            class: 'btn btn-blue',
                                            style: { width: '100%' },
                                            actionType: 'o365_onedrive_file_vault_move',
                                            hiddenEntityAny: {
                                                is_quarantined: true,
                                                is_deleted: true,
                                                is_vaulted: true
                                            }
                                        },
                                        {
                                            autoId: 'profile_manual_action_btn_o365_onedrive_file_vault_restore',
                                            class: 'btn btn-blue',
                                            style: { width: '100%' },
                                            actionType: 'o365_onedrive_file_vault_restore',
                                            hiddenEntityAny: {
                                                is_quarantined: true,
                                                is_deleted: true,
                                                is_vaulted: false
                                            }
                                        },
                                        {
                                            autoId: 'profile_manual_action_btn_o365_onedrive_file_remove',
                                            class: 'btn btn-blue',
                                            style: { width: '100%' },
                                            actionType: 'o365_onedrive_file_remove',
                                            hiddenEntityAny: {
                                                is_quarantined: true,
                                                is_deleted: true,
                                                is_vaulted: true
                                            }
                                        }
                                    ] : [],
                                    entityData: input.originData
                                };
                            }
                        });
                        if (restoreUpdateTickAfter && restoreUpdateTickAfter.isBefore(moment())) {
                            restoreUpdateTickAfter = null;
                            updateWidget = restartUpdating(updateWidget, updateTick);
                        }
                    }, function (err) {
                        console.log('Error in o365_onedrive file info:', err);
                    });
                };
                $scope.mainQueueDebug = mainQueueTroubleshootingHelper.button();
                updateWidget = $interval(function () {
                    $scope.loadData();
                }, updateTick);
                widgetPolling.on('remediationActionPerformed', function () {
                    restoreUpdateTickAfter = moment().add(30, 'seconds');
                    updateWidget = restartUpdating(updateWidget, 3000);
                });
                $scope.$on('file-recheck', function (event, eventData) {
                    recheckParams.show('Do you want to recheck this file?', eventData.entityType).then(function (data) {
                        return fileDao.recheck(eventData.entityType, eventData.entityId, data.selectApplications ? data.apps : undefined);
                    }).then(function () {
                        $rootScope.$broadcast('file-security-stack-reload');
                    });
                });
                if (troubleshooting.entityDebugEnabled()) {
                    $scope.$on('file-report', function (event, eventData) {
                        suspiciousReportParams.show('Report this file', eventData.entityType, eventData.entityId, { objectTypesData: widgetPolling.scope().objectTypes && widgetPolling.scope().objectTypes.data }).then(function (data) {
                            return fileDao.suspiciousReport(eventData.entityType, eventData.entityId, data);
                        });
                    });
                }
                $scope.$on('$locationChangeStart', function () {
                    if (updateWidget) {
                        $interval.cancel(updateWidget);
                    }
                });
            }
        };
    }]);
}());